import { render, staticRenderFns } from "./FeaturedGoodsPicker.vue?vue&type=template&id=3d615986&scoped=true&"
import script from "./FeaturedGoodsPicker.vue?vue&type=script&lang=js&"
export * from "./FeaturedGoodsPicker.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedGoodsPicker.vue?vue&type=style&index=0&id=3d615986&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d615986",
  null
  
)

export default component.exports